import script from "./LotteryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./LotteryCard.vue?vue&type=script&setup=true&lang=ts"

import "./LotteryCard.vue?vue&type=style&index=0&id=61b40784&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61b40784"]])

export default __exports__